import { useMemo } from 'react';
import { round2 } from './useQuarterHelpers';

/**
 * Calcul du CA net par consultant (CA - quote-part)
 * quotePart peut être :
 * - un objet { shared, byConsultant } (nouveau format avec charges par consultant)
 * - un objet quarterlyData simple { Q1, Q2, ... } (ancien format, rétro-compatible)
 */
export function useConsultantCalculations(caByConsultant, quotePart) {
  return useMemo(() => {
    const result = {};
    const hasByConsultant = quotePart && quotePart.byConsultant;

    Object.keys(caByConsultant).forEach(consultant => {
      const qp = hasByConsultant
        ? (quotePart.byConsultant[consultant] || quotePart.shared || { Q1: 0, Q2: 0, Q3: 0, Q4: 0, ANNUEL: 0 })
        : quotePart;

      result[consultant] = {
        Q1: round2(caByConsultant[consultant].Q1 - qp.Q1),
        Q2: round2(caByConsultant[consultant].Q2 - qp.Q2),
        Q3: round2(caByConsultant[consultant].Q3 - qp.Q3),
        Q4: round2(caByConsultant[consultant].Q4 - qp.Q4),
        ANNUEL: round2(caByConsultant[consultant].ANNUEL - qp.ANNUEL)
      };
    });

    return result;
  }, [caByConsultant, quotePart]);
}
